<template>
<v-layout>

  <v-dialog
    v-model="loading"
    hide-overlay
    persistent
    width="300"
    >
    <v-card
      color="orange"
      dark
      >
      <v-card-text>
        Please stand by
        <v-progress-linear
          indeterminate
          color="white"
          class="mb-0"
          ></v-progress-linear>
      </v-card-text>
    </v-card>
  </v-dialog>

      <v-col offset-md="1" md="10">


  <v-container grid-list-xl text-center>
    <v-layout wrap>
      <v-flex md8>

        <v-card dark color="amber darken-4" class="elevation-10">
          <v-card-text>
            <span class="display-1 font-weight-medium">Models store state </span>
            <br/>
            <span class="display-1 font-weight-thin">@ {{ report.reportDate }} (prod {{ prodName }})</span>
            <br/>

            <v-overflow-btn
              v-model="prodName"
              class="my-2"
              :items="prods"
              label="Select prod server"
              target="#dropdown-example"
              color="amber darken-4"
              ></v-overflow-btn>
          </v-card-text>
        </v-card>

        <br/>

        <v-card dark color="green" class="elevation-10">
          <v-card-text>
            <span class="display-1 font-weight-medium">Refresh </span>
            <br/>

            <v-overflow-btn
              v-model="refreshRate"
              class="my-2"
              :items="refreshRates"
              label="Refresh interval"
              target="#dropdown-example"
              color="green"
              ></v-overflow-btn>
          </v-card-text>
        </v-card>

      </v-flex>

      <v-flex md4>

        <v-date-picker
          class="elevation-10"
          style="margin: 0"
          :reactive="reactive"
          v-model="wantedReportDate"
          color="amber darken-4"
          ></v-date-picker>

      </v-flex>
    </v-layout>
  </v-container>

  <v-container text-center v-if="errorState">
  <v-card
    max-width="500"
    class="mx-auto"
    color="red"
    >
    <v-card-text>
      <span class="display-1 font-weight-medium">No data for this date</span>
      <br/>
      <br/>
      <v-icon>fa-exclamation</v-icon>
    </v-card-text>
  </v-card>
  </v-container>


  <div  v-for="run in report.report" :key="run.name" v-else>
    <span class="display-1">Run {{ run.name }}</span>
    <br/>

    <v-simple-table
      :fixed-header="fixedHeader"
      height="100%"
      class="elevation-10"
      >

      <thead>
        <tr>
          <th class="text-left">Source</th>
          <th class="text-left">Expected files</th>
          <th class="text-left">Stored files</th>
          <th class="text-left">Status</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in run.files" :key="item.run + item.source">
          <td>{{ item.source }}</td>
          <td>{{ item.expected_files }}</td>
          <td>{{ item.stored_files }}</td>

	  <td>
	    <Indicator :expected="item.expected_files" :available="item.stored_files"></Indicator>
	  </td>
        </tr>
      </tbody>
    </v-simple-table>

    <br/>

  </div>

</v-col>
</v-layout>
</template>

<script>
import { config } from '../config';

import Indicator from './Indicator.vue';

export default {
    components: {
	Indicator
    },
    data: () => (
	{
        reactive: true,
        loading: true,
        fixedHeader: true,
        report: {},
        errorState: false,
        prods: config.prods,
        prodName: config.prods[0],
        wantedReportDate: new Date().toISOString().substr(0, 10),
        refreshRates: config.refreshRates,
        refreshRate: 0,
        timer: 0,
    }),

    watch: {
        prodName() {
            this.loadData();
        },

        wantedReportDate() {
            this.timer = 0;
            this.refreshRate = 0;
            this.loadData();
        },

        refreshRate() {
            this.wantedReportDate = new Date().toISOString().substr(0, 10);
            this.loadInterval();
            if (this.refreshRate === 0) {
                clearInterval(this.timer);
            }
        },
    },

    created() {
        this.loadData();
        this.loadInterval();
    },

    methods: {
        loadData() {
            this.loading = true;
            const url = `${config.baseUrl}models?prodname=${this.prodName}&date=${this.wantedReportDate}`;

            this.$http.get(url, { auth: this.$store.getters.auth }).then((res) => {
                this.report = res.data;
                this.loading = false;
                this.errorState = false;
            }).catch((err) => {
                console.log(err);
                this.errorState = true;
                this.loading = false;
            });
        },

        loadInterval() {
            if (this.refreshRate !== 0) {
                this.timer = setInterval(this.loadData, this.refreshRate * 1000);
            }
        },
    },
};
</script>


<style lang="scss" scoped>
@font-face {
    font-family: "condensed-bold";
    src: url("../assets/fonts/YanoneKaffeesatz-Bold.ttf");
}

@font-face {
    font-family: "condensed-extralight";
    src: url("../assets/fonts/YanoneKaffeesatz-ExtraLight.ttf");
}

@font-face {
    font-family: "condensed-Light";
    src: url("../assets/fonts/YanoneKaffeesatz-Light.ttf");
}

@font-face {
    font-family: "condensed-reg";
    src: url("../assets/fonts/YanoneKaffeesatz-Regular.ttf");
}

.display-1 {
    font-family: 'condensed-extralight';
}
</style>
